import { render, staticRenderFns } from "./CreateCorsDialog.vue?vue&type=template&id=7c6e2183&"
import script from "./CreateCorsDialog.vue?vue&type=script&lang=js&"
export * from "./CreateCorsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports